import { useQuery } from '@tanstack/react-query';

import { getGiftWithPurchaseItems } from 'api/jalapeno';

import useAccountQuery from './useAccountQuery';

export const GIFT_WITH_PURCHASE_ITEMS_QUERY_KEY = 'gift-with-purchase-items';

/**
 * Query hook for fetching Gift With Purchase (GWP) items.
 * Returns items available as free gifts for new customers.
 *
 * @param {Object} options - Query options
 * @param {boolean} [options.enabled=true] - Whether the query should run
 * @returns {Object} React Query result with items data
 */
const useGiftWithPurchaseItemsQuery = ({ enabled = true } = {}) => {
    const { data: account } = useAccountQuery();

    const query = useQuery({
        queryKey: [GIFT_WITH_PURCHASE_ITEMS_QUERY_KEY, account?.nextOrder?.chargeID],
        queryFn: async () => {
            const response = await getGiftWithPurchaseItems(account?.nextOrder?.chargeID);
            return response?.data?.items ?? [];
        },
        enabled: !!account?.nextOrder?.chargeID && enabled,
    });

    return query;
};

export default useGiftWithPurchaseItemsQuery;
